//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'AddHeadHuntingGroupDialog',

	data() {
		return {
			name: null,
			error: null,
		};
	},

	methods: {
		async addGroup() {
			this.error = null;

			if (!this.name) {
				this.error = 'The name field is required.';
				return;
			}

			await this.$store
				.dispatch('headHunting/groups/addGroup', {
					name: this.name,
				})
				.then(() => {
					this.$emit('close-modal');

					this.$toast.show({
						type: 'success',
						message: 'Group added successfully!',
					});
				})
				.catch((error) => {
					this.error = error.response.data.message;
				});
		},
	},
};
